import { CLUserStateKey } from '@local/domain';
import * as yup from 'yup';

export type UserUpdateSchemaType = {
  userName: string; //
};

/**
 * form validation schema for login
 */
export const userUpdateSchema: yup.SchemaOf<UserUpdateSchemaType> = yup.object().shape({
  userName: yup.string().required('로그인ID를 입력해주세요'),
});
